import React, { useState, useEffect } from "react";
import { Image } from "antd";
import { SkinOutlined } from "@ant-design/icons";
import http from "../../../../../services/http";

export function RenderImageCard({ idImagem }) {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!idImagem) return;
		const fetchImage = async () => {
			setLoading(true);
			const api = await http("file", `v1/uniformes_produtos_imagens/carregar_imagem/${idImagem}`);
			if (api.statusCode === 200) {
				const url = window.URL.createObjectURL(api.response.data);
				setData(url);
			}
			setLoading(false);
		};
		fetchImage();
	}, [idImagem]);

	if (loading || !data) {
		return (
			<div className="image-content">
				<div className="image-loading">
					<SkinOutlined />
				</div>
			</div>
		);
	}

	return (
		<div className="image-content">
			<Image src={data} width="100%" preview={false} height="100%" className="render-image" />
		</div>
	);
}
